import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';
import {
  GET_DASHBOARD_TASKS_REQUEST,
  GET_DASHBOARD_TASKS_SUCCESS,
  GET_DASHBOARD_TASKS_FAILURE,
  GET_EXPENSE_FOLLOWUP_REQUEST,
  GET_EXPENSE_FOLLOWUP_SUCCESS,
  GET_EXPENSE_FOLLOWUP_FAILURE,
  GET_RECURRING_PAYABLES_DASHBOARD_REQUEST,
  GET_RECURRING_PAYABLES_DASHBOARD_SUCCESS,
  GET_RECURRING_PAYABLES_DASHBOARD_FAILURE,
  GET_EXTERNAL_COMMENTS_REQUEST,
  GET_EXTERNAL_COMMENTS_SUCCESS,
  GET_EXTERNAL_COMMENTS_FAILURE,
  GET_EXCEPTION_COMMENTS_REQUEST,
  GET_EXCEPTION_COMMENTS_SUCCESS,
  GET_EXCEPTION_COMMENTS_FAILURE,
  CREATE_MANUAL_TASK_REQUEST,
  CREATE_MANUAL_TASK_SUCCESS,
  CREATE_MANUAL_TASK_FAILURE,
  GET_VOUCHER_CONTEXT_REQUEST,
  GET_VOUCHER_CONTEXT_SUCCESS,
  GET_VOUCHER_CONTEXT_FAILURE,
  GET_LETTER_TEMPLATE_REQUEST,
  GET_LETTER_TEMPLATE_SUCCESS,
  GET_LETTER_TEMPLATE_FAILURE,
  GET_RC_FILES_REQUEST,
  GET_RC_FILES_SUCCESS,
  GET_RC_FILES_FAILURE,
  GET_LETTER_TEMPLATES_REQUEST,
  GET_LETTER_TEMPLATES_SUCCESS,
  GET_LETTER_TEMPLATES_FAILURE,
  GET_TASK_COMMENTS_REQUEST,
  GET_TASK_COMMENTS_SUCCESS,
  GET_TASK_COMMENTS_FAILURE,
  SET_DASHBOARD_FILTERS,
  SET_TASK_FILTERS,
  SET_EXPENSE_FILTERS,
  SET_EXTERNAL_COMMENTS_FILTERS,
  SET_EXCEPTION_COMMENTS_FILTERS,
  RESET_FILTERS,
  SET_ACTIVE_MODAL,
  CLOSE_MODAL,
  UPDATE_TASK_REQUEST,
  UPDATE_TASK_SUCCESS,
  UPDATE_TASK_FAILURE
} from './types';

// Fetch dashboard tasks for the given user
export const getDashboardTasks = (userId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_DASHBOARD_TASKS_REQUEST, GET_DASHBOARD_TASKS_SUCCESS, GET_DASHBOARD_TASKS_FAILURE],
    authenticated: true,
    endpoint: `api/tasks/dashboard/${userId}`,
    method: 'GET',
  }
});

// Get expense follow-up data (unapproved expenses for RC's files)
export const getExpenseFollowUp = (userId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_EXPENSE_FOLLOWUP_REQUEST, GET_EXPENSE_FOLLOWUP_SUCCESS, GET_EXPENSE_FOLLOWUP_FAILURE],
    authenticated: true,
    endpoint: `api/expenses/followup/${userId}`,
    method: 'GET',
  }
});

export const getRecurringPayablesDashboard = (userId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [
      GET_RECURRING_PAYABLES_DASHBOARD_REQUEST,
      GET_RECURRING_PAYABLES_DASHBOARD_SUCCESS,
      GET_RECURRING_PAYABLES_DASHBOARD_FAILURE,
    ],
    authenticated: true,
    endpoint: `api/recurringPayables/dashboard/${userId}`,
    method: 'GET',
  }
});

// Get external comments (transferee-viewable comments for RC's files)
export const getExternalComments = (userId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_EXTERNAL_COMMENTS_REQUEST, GET_EXTERNAL_COMMENTS_SUCCESS, GET_EXTERNAL_COMMENTS_FAILURE],
    authenticated: true,
    endpoint: `api/comments/external/${userId}`,
    method: 'GET',
  }
});

// Get exception comments (exception requests for RC's files)
export const getExceptionComments = (userId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_EXCEPTION_COMMENTS_REQUEST, GET_EXCEPTION_COMMENTS_SUCCESS, GET_EXCEPTION_COMMENTS_FAILURE],
    authenticated: true,
    endpoint: `api/comments/exceptions/${userId}`,
    method: 'GET',
  }
});

// update task — PUT full task with unchanged status
export const updateTask = (task) => ({
  [CALL_INTAKE_V2_API]: {
    types: [UPDATE_TASK_REQUEST, UPDATE_TASK_SUCCESS, UPDATE_TASK_FAILURE],
    authenticated: true,
    endpoint: 'api/tasks',
    method: 'PUT',
    payload: task,
  }
});



// Complete task — PUT full task with status set to Completed (4)
// export const completeTask = (task) => ({
//   [CALL_INTAKE_V2_API]: {
//     types: [COMPLETE_TASK_REQUEST, COMPLETE_TASK_SUCCESS, COMPLETE_TASK_FAILURE],
//     authenticated: true,
//     endpoint: 'api/tasks',
//     method: 'PUT',
//     payload: { ...task, taskStatusId: 4 },
//   }
// });

// Cancel task — PUT full task with status set to Canceled (3)
// export const cancelTask = (task) => ({
//   [CALL_INTAKE_V2_API]: {
//     types: [CANCEL_TASK_REQUEST, CANCEL_TASK_SUCCESS, CANCEL_TASK_FAILURE],
//     authenticated: true,
//     endpoint: 'api/tasks',
//     method: 'PUT',
//     payload: { ...task, taskStatusId: 3 },
//   }
// });

// Create manual task
export const createManualTask = (taskPayload) => ({
  [CALL_INTAKE_V2_API]: {
    types: [CREATE_MANUAL_TASK_REQUEST, CREATE_MANUAL_TASK_SUCCESS, CREATE_MANUAL_TASK_FAILURE],
    authenticated: true,
    endpoint: 'api/tasks',
    method: 'POST',
    payload: taskPayload
  }
});

// Get voucher context for Voucher/VendorVoucher tasks
export const getVoucherContext = (taskId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_VOUCHER_CONTEXT_REQUEST, GET_VOUCHER_CONTEXT_SUCCESS, GET_VOUCHER_CONTEXT_FAILURE],
    authenticated: true,
    endpoint: `api/tasks/${taskId}/voucher-context`,
    method: 'GET'
  }
});

// Get letter template for Letter/VendorLetter tasks
export const getLetterTemplate = (taskId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_LETTER_TEMPLATE_REQUEST, GET_LETTER_TEMPLATE_SUCCESS, GET_LETTER_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: `api/tasks/${taskId}/letter-template`,
    method: 'GET'
  }
});

// Get RC files (authorization summaries filtered by userId)
export const getRCFiles = (userId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_RC_FILES_REQUEST, GET_RC_FILES_SUCCESS, GET_RC_FILES_FAILURE],
    authenticated: true,
    endpoint: `api/authorizations/summaries?userId=${userId}`,
    method: 'GET'
  }
});

// Get all letter templates
export const getLetterTemplates = () => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_LETTER_TEMPLATES_REQUEST, GET_LETTER_TEMPLATES_SUCCESS, GET_LETTER_TEMPLATES_FAILURE],
    authenticated: true,
    endpoint: 'api/letter-templates',
    method: 'GET'
  }
});

// Get comments for a specific task
export const getTaskComments = (taskId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_TASK_COMMENTS_REQUEST, GET_TASK_COMMENTS_SUCCESS, GET_TASK_COMMENTS_FAILURE],
    authenticated: true,
    endpoint: `api/tasks/${taskId}/comments`,
    method: 'GET'
  },
  meta: { taskId } // Pass taskId to reducer
});

// Local filter actions (synchronous)
export const setDashboardFilters = (filters) => ({
  type: SET_DASHBOARD_FILTERS,
  payload: filters
});

export const setTaskFilters = (filters) => ({
  type: SET_TASK_FILTERS,
  payload: filters
});

export const setExpenseFilters = (filters) => ({
  type: SET_EXPENSE_FILTERS,
  payload: filters
});

export const setExternalCommentsFilters = (filters) => ({
  type: SET_EXTERNAL_COMMENTS_FILTERS,
  payload: filters
});

export const setExceptionCommentsFilters = (filters) => ({
  type: SET_EXCEPTION_COMMENTS_FILTERS,
  payload: filters
});

export const resetFilters = () => ({
  type: RESET_FILTERS
});

// Modal management
export const openModal = (modalType, task) => ({
  type: SET_ACTIVE_MODAL,
  payload: { modalType, task }
});

export const closeModal = () => ({
  type: CLOSE_MODAL
});
